const pains = [
  {
    title: "个体户没进出口权，有货出不去",
    desc: "小商品、多品种、小批量，没有进出口经营权，传统一般贸易门槛高——市场采购贸易方式让你无需自营进出口权也能阳光出口，采购、报关一站搞定，把\"出不去\"变成\"出得去\"。",
    icon: "ri-store-2-line",
    grad: "from-red-500 to-red-600",
    feature: "无资质也能出口",
  },
  {
    title: "无票采购难退税，税负压得慌",
    desc: "从小商品市场采购拿不到进项发票，无法正常退税——市场采购贸易实行\"免征不退\"，增值税免征，无需退税、无需进项发票，把\"无票\"的难题直接绕过去，税负压力大幅下降。",
    icon: "ri-file-forbid-line",
    grad: "from-accent-500 to-accent-400",
    feature: "免征不退",
  },
  {
    title: "收汇结汇不阳光，资金风险大",
    desc: "地下钱庄、私账收汇有风险，资金不合规还怕被查——市场采购贸易通过联网信息平台阳光收结汇，货款直接结到境内账户，每一笔都留痕、可追溯，把\"灰色\"变成\"阳光\"。",
    icon: "ri-exchange-funds-line",
    grad: "from-primary-500 to-primary-600",
    feature: "阳光收汇",
  },
];

export default function PainPoints() {
  return (
    <section id="features" className="py-16 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-4">
          <h2 className="text-[28px] md:text-[38px] font-heading font-bold text-foreground-800 mb-4 tracking-tight">
            一个平台解决三大痛点
          </h2>
          <div className="w-12 h-1.5 bg-gradient-to-r from-accent-500 to-accent-400 mx-auto rounded-full" />
        </div>
        <p className="text-center text-foreground-600 text-[15px] md:text-[17px] mb-12 md:mb-16 font-medium">
          出口不难，是没找对方式：市场采购贸易，帮你少门槛、少税负、少风险。
        </p>

        <div className="grid md:grid-cols-3 gap-5 md:gap-8">
          {pains.map((p, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-3xl p-7 md:p-10 border-2 border-background-200 hover:border-primary-300 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.04)] hover:-translate-y-1 transition-all duration-300 flex flex-col h-full"
            >
              <div className="flex items-center justify-between mb-6">
                <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br flex items-center justify-center ${p.grad}`}>
                  <i className={`text-background-50 text-2xl md:text-3xl ${p.icon}`} />
                </div>
                <span className="text-xs font-medium text-primary-600 bg-primary-50 border border-primary-100 px-3 py-1 rounded-full">
                  {p.feature}
                </span>
              </div>
              <h3 className="text-[19px] md:text-[22px] font-bold text-foreground-800 mb-4 leading-snug">
                {p.title}
              </h3>
              <p className="text-[14px] md:text-[15px] text-foreground-500 leading-relaxed flex-grow">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}